"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditions = void 0;
var _auth = require("@ori/auth");
var _react = require("react");
var _getTermsAndConditionsCookie = require("../utils/getTermsAndConditionsCookie");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TermsAndConditionsValidatorLazy = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "TermsAndConditionsValidatorLazy" */'./TermsAndConditionsValidator/TermsAndConditionsValidatorLazy')))).TermsAndConditionsValidatorLazy
}));
const TermsAndConditions = () => {
  const {
    isAnonymousUser,
    isUserVerified,
    customerId
  } = (0, _auth.useToken)();
  if (!isAnonymousUser && isUserVerified && customerId !== (0, _getTermsAndConditionsCookie.getTermsAndConditionsCookie)()) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(TermsAndConditionsValidatorLazy, {});
  }
  return null;
};
exports.TermsAndConditions = TermsAndConditions;
